<template>
  <div>
    <my-notification :icon="'book'">
      <template #title>
        {{ $t('compScenarioDocsManual.title') }}
      </template>
    </my-notification>
    <br />
    <b-tabs>
      <b-tab-item icon="info" :label="$t('compScenarioDocsManual.title-1')">
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-1-1') }}</strong>
          <br />
          {{ $t('compScenarioDocsManual.manual-1-2') }}
          <ul style="list-style-type: square; margin-left: 25px">
            <li><span v-html="$t('compScenarioDocsManual.manual-1-3')" /></li>
            <li><span v-html="$t('compScenarioDocsManual.manual-1-4')" /></li>
          </ul>
        </b-notification>
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-2-1') }}</strong
          ><br />
          <span v-html="$t('compScenarioDocsManual.manual-2-2')" />
        </b-notification>
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-3-1') }}</strong
          ><br />
          {{ $t('compScenarioDocsManual.manual-3-2') }}
          <ul style="list-style-type: square; margin-left: 25px">
            <li><span v-html="$t('compScenarioDocsManual.manual-3-3')" /></li>
            <li><span v-html="$t('compScenarioDocsManual.manual-3-4')" /></li>
            <li><span v-html="$t('compScenarioDocsManual.manual-3-5')" /></li>
          </ul>
          <span v-html="$t('compScenarioDocsManual.manual-3-6')" />
        </b-notification>
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-4-1') }}</strong
          ><br />
          <span v-html="$t('compScenarioDocsManual.manual-4-2')" />
        </b-notification>
      </b-tab-item>
      <b-tab-item icon="cogs" :label="$t('compScenarioDocsManual.title-2')">
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-6-1') }}</strong
          ><br />
          <span v-html="$t('compScenarioDocsManual.manual-6-2')" /><br />
          <span v-html="$t('compScenarioDocsManual.manual-6-3')" /><br />
          <span v-html="$t('compScenarioDocsManual.manual-6-4')" />
        </b-notification>
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-7-1') }}</strong
          ><br />
          <span v-html="$t('compScenarioDocsManual.manual-7-2')" />
        </b-notification>
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-8-1') }}</strong
          ><br />
          <span v-html="$t('compScenarioDocsManual.manual-8-2')" />
        </b-notification>
        <b-notification :closable="false">
          <strong>{{ $t('compScenarioDocsManual.manual-9-1') }}</strong
          ><br />
          <span v-html="$t('compScenarioDocsManual.manual-9-2')" />
        </b-notification>
      </b-tab-item>
      <b-tab-item
        icon="crosshairs"
        :label="$t('compScenarioDocsManual.title-3')"
      >
        <b-notification
          v-for="(module, indexm) in modules"
          :key="indexm"
          :closable="false"
        >
          <b-icon :icon="getIcon(module)" />
          <strong>{{ $t(module) }}</strong
          ><br />
          <ul style="list-style-type: square; margin-left: 25px">
            <li v-for="(rule, indexr) in getModuleRules(module)" :key="indexr">
              « {{ translate(rule, 'title') }} » :
              <span v-html="translate(rule, 'manual')" />
            </li>
          </ul>
        </b-notification>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import Rule from '@/models/scenario/Rule.js'
import Scenario from '@/models/scenario/Scenario.js'
import Modules from '@/models/Modules.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'Manual',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    modules: function () {
      // we only want the top level module types of active modules
      return this.coreStore.activeModules(false)
    },
    activeScenarios: function () {
      return this.coreStore.conf.ACTIVE_RULES.value
    }
  },
  methods: {
    getIcon: function (module) {
      return Modules.getIcon(module)
    },
    getModuleRules: function (module) {
      return Scenario.getRules(this.activeScenarios).filter(
        (obj) => Modules.getParentModule(obj.module) === module
      )
    },
    translate (rule, key) {
      return Rule.translate(rule, key, this.$i18n.locale)
    }
  }
}
</script>
